









































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';

@Component({
        name: 'BankAccountDelete',
    },
)
export default class BankAccountDelete extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public bankAccountName: string = '';
    public confirmDelete: boolean = false;
    public authorized: boolean = false;

    public confirmDeleteRules(value: boolean): any {
        if ( !value )
        {
            return 'Please confirm that you want to delete this bank account.';
        }

        return true;
    }

    public created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.DELETE )
        {
            this.authorized = true;
            this.bankAccountName = this.$store.state.selectedBankAccount.bankAccountName;
        }
    }

    public async deleteClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const api = new BankAccountsApi();
                const response = await api.deleteAsync(this.bankAccountId, this.$store.state.member.jwt);

                await this.$router.push({name: 'memberbankaccounts'});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.bankAccountDeleteForm;

        return form.validate();
    }

}

